// Exact original and fair-bundle pairs; display only, no inventory/order writes.
const approvedPairs = new Map([
  ['15950359986557', '58354284724605'],
  ['15749037326717', '57651972800893'],
  ['15750526108029', '57657628590461'],
  ['15750528500093', '57657646973309'],
  ['16044573065597', '58775259709821'],
  ['16044575261053', '58775272227197'],
  ['16044576801149', '58775276552573'],
  ['16044579750269', '58775291068797'],
]);
const bundleSources = new Map([
  ['58775259709821','58354284724605'], ['58775272227197','57651972800893'],
  ['58775276552573','57657628590461'], ['58775291068797','57657646973309'],
]);
export function sourceCartQuantity(items, sourceVariantId) {
  return items.reduce((sum,item)=>{
    const variant=String(item.variant_id || item.id),product=String(item.product_id);
    // Cart events may omit product_id; exact globally unique variant IDs remain allowlisted.
    if(item.product_id != null ? approvedPairs.get(product)!==variant : ![...approvedPairs.values()].includes(variant))return sum;
    return (bundleSources.get(variant)||variant)===String(sourceVariantId) ? sum+Number(item.quantity) : sum;
  },0);
}
export function pilotDelayed(state, requested = 1, cartQuantity = 0) {
  return approvedPairs.get(String(state.productId)) === String(state.variantId)
    && (!bundleSources.has(String(state.variantId)) || bundleSources.get(String(state.variantId))===String(state.sourceVariantId))
    && state.sourceValid !== 'false'
    && state.tracked === 'shopify' && state.policy === 'continue'
    && Number.isFinite(Number(state.available))
    && Number(requested) + Number(cartQuantity) > Number(state.available);
}

if (typeof customElements !== 'undefined' && !customElements.get('r3-backorder-pilot')) {
  class PilotMessage extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.form = document.getElementById(this.dataset.formId);
      this.section = this.closest('.shopify-section');
      this.section?.addEventListener('input',()=>this.update(),options);
      this.section?.addEventListener('change',()=>this.update(),options);
      document.addEventListener('quantity-selector:update',()=>this.update(),options);
      this.section?.addEventListener('variant:update',event=>{
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        const incoming = [...(event.detail.data.html?.querySelectorAll('r3-backorder-pilot') || [])]
          .find(el=>el.dataset.formId===this.dataset.formId && el.dataset.mode===this.dataset.mode);
        if (incoming && String(event.detail.resource?.id)===incoming.dataset.variantId) {
          for(const key of ['variantId','sourceVariantId','sourceValid','available','policy','tracked','cartQty']) this.dataset[key]=incoming.dataset[key];
        } else { this.dataset.variantId=String(event.detail.resource?.id || ''); }
        queueMicrotask(()=>this.update());
      },options);
      document.addEventListener('cart:update',event=>{
        const resource=event.detail?.resource;
        // Only a complete acknowledged cart is an absolute cart quantity.
        if(Array.isArray(resource?.items) && typeof resource.item_count==='number') {
          this.dataset.cartQty=String(sourceCartQuantity(resource.items,this.dataset.sourceVariantId || this.dataset.variantId));
        }
        this.update();
        this.refresh();
      },options);
      window.addEventListener('pageshow',()=>this.refresh(),options);
      this.update();
    }
    disconnectedCallback(){this.controller?.abort();this.readController?.abort();}
    update(){
      this.form = document.getElementById(this.dataset.formId);
      const selected=this.form?.querySelector('[name="id"]')?.value || this.dataset.variantId;
      const qty=Number(this.form?.querySelector('[name="quantity"]')?.value || this.dataset.requested || 1);
      const delayed=pilotDelayed({...this.dataset,variantId:selected},qty,Number(this.dataset.cartQty || 0));
      const warning=this.querySelector('[data-pilot-warning]'),normal=this.querySelector('[data-pilot-normal]');
      if(warning)warning.hidden=!delayed;
      if(normal)normal.hidden=delayed || this.dataset.sourceValid==='false' || (this.freshnessUnknown && this.dataset.policy==='continue');
    }
    async refresh(){
      this.readController?.abort();this.readController=new AbortController();
      const signal=this.readController.signal;
      this.freshnessUnknown=true;this.update();
      try {
        const url=new URL(this.dataset.productUrl,location.origin);
        url.searchParams.set('section_id',this.dataset.sectionId);
        url.searchParams.set('variant',this.dataset.variantId);
        const response=await fetch(url,{signal,cache:'no-store'});
        if(!response.ok)throw new Error('Pilot delivery state unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        if(signal.aborted || !this.isConnected)return;
        const incoming=[...doc.querySelectorAll('r3-backorder-pilot')].find(el=>el.dataset.formId===this.dataset.formId && el.dataset.mode===this.dataset.mode && el.dataset.variantId===this.dataset.variantId);
        if(!incoming)throw new Error('Pilot delivery state missing');
        for(const key of ['sourceVariantId','sourceValid','available','policy','tracked','cartQty'])this.dataset[key]=incoming.dataset[key];
        this.freshnessUnknown=false;
        this.update();
      } catch(error){
        // Retain server-rendered warning on failure; never claim a successful fresh check.
        if(error.name!=='AbortError')console.warn('Pilot delivery refresh unavailable');
      }
    }
  }
  customElements.define('r3-backorder-pilot',PilotMessage);
}
